import * as React from "react";

import "./Loading.scss";

interface Props {
  css?: string | null;
}

export default ({ css }: Props) => {
  return (
    <div className={"loadingIndicator fullscreen " + css}>
      <div className="linePreloader"></div>
    </div>
  );
};
